---
markset: 0
---

# What an error looks like

{.lead}
The vocabulary is closed, so an unknown directive is a diagnostic rather than
silent passthrough. Open the Problems tab.

:::accordion
Not a construct. Markset has eight, and this is not one of them.
:::

:::card
A card with no closing fence below it is the other common mistake.
